// removed by extract-text-webpack-plugin
module.exports = {"root":"root_3p1qA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Label/style.css
// module id = 184
// module chunks = 0